export const pojoMetadata = {
			'signature-request': {
			columns: [
			   	{ key: "id", name: "id", editable: false, resizable: true},
			   	{ key: "createdAt", name: "created_at", editable: true, resizable: true, type: "timestampz" },
			   	{ key: "initiatorId", name: "initiator_id", editable: true, resizable: true, type: "number" },
			   	{ key: "status", name: "status", editable: true, resizable: true, type: "number" },
			   	{ key: "updatedAt", name: "updated_at", editable: true, resizable: true, type: "timestampz" },
			],
			form2dto: (data) => {
				if(data.createdAt != null && data.createdAt instanceof Date)
					data.createdAt = data.createdAt.getFullYear() + "-" + ('0' + (data.createdAt.getMonth() + 1)).slice(-2) + "-" + ('0' + data.createdAt.getDate()).slice(-2);
				if(data.updatedAt != null && data.updatedAt instanceof Date)
					data.updatedAt = data.updatedAt.getFullYear() + "-" + ('0' + (data.updatedAt.getMonth() + 1)).slice(-2) + "-" + ('0' + data.updatedAt.getDate()).slice(-2);
				return data
			}
		},
		'locale': {
			columns: [
			   	{ key: "id", name: "id", editable: false, resizable: true},
			   	{ key: "name", name: "name", editable: true, resizable: true, type: "text" },
			],
			form2dto: (data) => {
				if(data.name == "")
					data.name = null;
				return data
			}
		},
		'signature-party': {
			columns: [
			   	{ key: "id", name: "id", editable: false, resizable: true},
			   	{ key: "email", name: "email", editable: true, resizable: true, type: "text" },
			   	{ key: "partyId", name: "party_id", editable: true, resizable: true, type: "number" },
			   	{ key: "signatureRequestId", name: "signature_request_id", editable: true, resizable: true, type: "number" },
			   	{ key: "signedAt", name: "signed_at", editable: true, resizable: true, type: "timestampz" },
			   	{ key: "status", name: "status", editable: true, resizable: true, type: "number" },
			],
			form2dto: (data) => {
				if(data.email == "")
					data.email = null;
				if(data.signedAt != null && data.signedAt instanceof Date)
					data.signedAt = data.signedAt.getFullYear() + "-" + ('0' + (data.signedAt.getMonth() + 1)).slice(-2) + "-" + ('0' + data.signedAt.getDate()).slice(-2);
				return data
			}
		},
		'signature-record': {
			columns: [
			   	{ key: "id", name: "id", editable: false, resizable: true},
			   	{ key: "signaturePartyId", name: "signature_party_id", editable: true, resizable: true, type: "number" },
			   	{ key: "signatureRequestId", name: "signature_request_id", editable: true, resizable: true, type: "number" },
			   	{ key: "signedAt", name: "signed_at", editable: true, resizable: true, type: "timestampz" },
			   	{ key: "signedHash", name: "signed_hash", editable: true, resizable: true, type: "text" },
			],
			form2dto: (data) => {
				if(data.signedAt != null && data.signedAt instanceof Date)
					data.signedAt = data.signedAt.getFullYear() + "-" + ('0' + (data.signedAt.getMonth() + 1)).slice(-2) + "-" + ('0' + data.signedAt.getDate()).slice(-2);
				if(data.signedHash == "")
					data.signedHash = null;
				return data
			}
		},
		'i18n': {
			columns: [
			   	{ key: "id", name: "id", editable: false, resizable: true},
			   	{ key: "domainId", name: "domain_id", editable: true, resizable: true, type: "text" },
			   	{ key: "localeId", name: "locale_id", editable: true, resizable: true, type: "number" },
			   	{ key: "messageId", name: "message_id", editable: true, resizable: true, type: "text" },
			   	{ key: "value", name: "value", editable: true, resizable: true, type: "text" },
			],
			form2dto: (data) => {
				if(data.domainId == "")
					data.domainId = null;
				if(data.messageId == "")
					data.messageId = null;
				if(data.value == "")
					data.value = null;
				return data
			}
		},
		'user-preferences': {
			columns: [
			   	{ key: "id", name: "id", editable: false, resizable: true},
			   	{ key: "key", name: "key", editable: true, resizable: true, type: "text" },
			   	{ key: "userId", name: "user_id", editable: true, resizable: true, type: "text" },
			   	{ key: "value", name: "value", editable: true, resizable: true, type: "text" },
			],
			form2dto: (data) => {
				if(data.key == "")
					data.key = null;
				if(data.userId == "")
					data.userId = null;
				if(data.value == "")
					data.value = null;
				return data
			}
		},
}

export const buildEmptyObject = (entity) => {
	var columns = new Object();
	let fields = pojoMetadata[entity].columns
	for (let col in fields) {		
		if(fields[col].type == 'text'){
			columns[fields[col].key] = "";
		}else if(fields[col].type=='checkbox'){
			columns[fields[col].key] = false;
		}else if(fields[col].type=='datetime-local'){
			columns[fields[col].key] = "";
		}
		else if(fields[col].type=='autocomplete'){
			columns[fields[col].key] = null;
		}
	 }
	return columns
};

export const getEntityIdCol = (entity) => {
	return pojoMetadata[entity].columns[0].key;
}

export const getRowId = (entity, row) => {
	return row[getEntityIdCol(entity)];
}

